"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const BaseAPIService_1 = require("./BaseAPIService");
const Services_1 = require("./Services");
class RatingTableService extends BaseAPIService_1.default {
    constructor(baseURL, token) {
        super(baseURL, 'billing/ratingTable', token);
    }
    rate(ratingTableId) {
        return new Services_1.RatingTableRateService(this.baseURL, this.token, ratingTableId);
    }
}
exports.default = RatingTableService;
